import { Injectable, Inject } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { timeout, retry, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MetricsService {
    private apiUrl = `${environment.apiHost}/metrics`;

    constructor(private http: HttpClient, @Inject(OKTA_AUTH) public oktaAuth: OktaAuth) {
    }

    async getMetricsHi() {
        return this.http.get(`${this.apiUrl}/hi`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(10000),
                retry(3),
                catchError(error => of("Request for /hi endpoint timed out!"))
            );
    }

    async getFortinetAvailabilityOrg() {
        return this.http.get(`${this.apiUrl}/fortinet/availability/org`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(10000),
                retry(3),
                catchError(error => of("Request for Fortinet Org availability timed out!"))
            );    
    }

    async getFortinetAvgOfflineEventsPerDay() {
        return this.http.get(`${this.apiUrl}/fortinet/avg-offline-events-per-day`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(10000),
                retry(3),
                catchError(error => of("Request for Fortinet offline events timed out!"))
            );    
    }

    async getMistAvailabilityOrg() {
        return this.http.get(`${this.apiUrl}/mist/availability/org`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(10000),
                retry(3),
                catchError(error => of("Request for Mist Org availability timed out!"))
            );    
    }

    async getCradlepointAvailabilityOrg() {
        return this.http.get(`${this.apiUrl}/cradlepoint/availability/org`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(10000),
                retry(3),
                catchError(error => of("Request for Cradlepoint Org availability timed out!"))
            );
    }

    async getCradlepointSpeedAnomalies() {
        return this.http.get(`${this.apiUrl}/cradlepoint/speeds/anomalies`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(10000),
                retry(3),
                catchError(error => of("Request for Cradlepoint speed anomalies timed out!"))
            );
    }

    async getCradlepointBestDownloads() {
        return this.http.get(`${this.apiUrl}/cradlepoint/speeds/best-downloads`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(10000),
                retry(3),
                catchError(error => of("Request for Cradlepoint top speeds timed out!"))
            );
    }

    async getCradlepointBestUploads() {
        return this.http.get(`${this.apiUrl}/cradlepoint/speeds/best-uploads`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(10000),
                retry(3),
                catchError(error => of("Request for Cradlepoint top speeds timed out!"))
            );
    }

    async getCradlepointWorstDownloads() {
        return this.http.get(`${this.apiUrl}/cradlepoint/speeds/worst-downloads`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(10000),
                retry(3),
                catchError(error => of("Request for Cradlepoint top speeds timed out!"))
            );
    }

    async getCradlepointWorstUploads() {
        return this.http.get(`${this.apiUrl}/cradlepoint/speeds/worst-uploads`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(10000),
                retry(3),
                catchError(error => of("Request for Cradlepoint top speeds timed out!"))
            );
    }

    async getKevlar2Progress() {
        return this.http.get(`${this.apiUrl}/kevlar2/progress`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(29000),
                retry(3),
                catchError(error => of("Request for Kevlar2 Progress timed out!"))
            );
    }

    async getSmartsheetMetrics() {
        return this.http.get(`${this.apiUrl}/kevlar2/smartsheet-metrics`,
            {
                headers: new HttpHeaders(
                    { "Authorization": "Bearer " + await this.oktaAuth.getAccessToken() }
                )
            }).pipe(
                timeout(20000),
                retry(3),
                catchError(error => of("Request for Smartsheet Metrics timed out!"))
            );
    }

}